/*
  Kopstorm - Intelligems rollouts (TOTE)

  Permanent theme implementations of winning Intelligems tests.
  One block per rollout, newest at the bottom. Keep the test code
  ([K_xx]) in the comment so results stay traceable.

  Loaded from layout/theme.liquid with defer, before global.js.
*/
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Rollout of Product Images [K_08]
     Product gallery opens on the lifestyle image instead of the
     studio shot.

     The flag is set synchronously in layout/theme.liquid and read by
     sliderInit() in global.js, which is the path that runs in
     practice. Everything below is a safety net for the cases where
     Swiper initialises before the flag is readable, or where
     data-current-index outranks it.
  --------------------------------------------------------------- */

  var TARGET_INDEX = 1; // 0 = studio, 1 = lifestyle
  var SELECTOR = '.js-media-list, .js-media-list-mobile';
  var TIMEOUT = 4000;
  var POLL = 50;

  // Fallback in case the inline flag in theme.liquid is ever removed.
  if (typeof window.__kvGalleryStartIndex !== 'number') {
    window.__kvGalleryStartIndex = TARGET_INDEX;
  }

  var aborted = false;

  function abort() {
    aborted = true;
  }

  /*
    Any real interaction cancels the safety net. Without this, a variant
    change inside the polling window would be yanked back to the
    lifestyle slide by updateMedia and this loop fighting each other.
  */
  document.addEventListener(
    'change',
    function (event) {
      if (event.target.closest && event.target.closest('variant-selects, variant-radios')) abort();
    },
    true
  );

  ['pointerdown', 'touchstart', 'keydown'].forEach(function (type) {
    document.addEventListener(type, abort, { capture: true, once: true, passive: true });
  });

  /**
   * Nudges every initialised gallery onto the target slide, once per
   * gallery. Returns true when there is nothing left to do, which
   * stops the polling.
   */
  function correctGalleries() {
    if (aborted) return true;

    var lists = document.querySelectorAll(SELECTOR);
    if (!lists.length) return true;

    var handled = 0;

    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];

      // Already dealt with on an earlier pass.
      if (list.dataset.kvGalleryRolledOut) {
        handled++;
        continue;
      }

      // Not initialised yet, keep polling.
      if (!list.swiper) continue;

      var slides = list.querySelectorAll('.swiper-slide').length;
      var index = TARGET_INDEX;

      // Single image product (or fewer slides than the target).
      if (index > slides - 1) index = slides - 1;
      if (index < 0) index = 0;

      list.dataset.kvGalleryRolledOut = '1';
      handled++;

      // Primary path already did the job, leave the DOM alone.
      if (list.swiper.activeIndex === index) continue;

      // Written so the breakpoint re-init in sliderInit() keeps the slide.
      list.dataset.currentIndex = index;
      list.swiper.slideTo(index, 0);
    }

    return handled === lists.length;
  }

  function watchGalleries() {
    if (aborted) return;
    if (!document.querySelector(SELECTOR)) return;

    var start = Date.now();

    var timer = setInterval(function () {
      if (correctGalleries() || Date.now() - start > TIMEOUT) {
        clearInterval(timer);
      }
    }, POLL);
  }

  watchGalleries();

  // Theme editor section reload: the markup is replaced, so start over.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector(SELECTOR)) {
      aborted = false;
      watchGalleries();
    }
  });
})();